import { Check, ChevronDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { useCurrency, CURRENCIES } from "@/contexts/CurrencyContext";
import { SUPPORTED_CURRENCY_CODES } from "@/lib/currency";
import { cn } from "@/lib/utils";

interface CurrencySelectorProps {
  className?: string;
  compact?: boolean;
}

export function CurrencySelector({ className, compact = false }: CurrencySelectorProps) {
  const { currency, setCurrency } = useCurrency();
  const current = CURRENCIES[currency];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className={cn("gap-1.5 px-2 h-9", className)}
          aria-label="Select currency"
        >
          <span className="text-base leading-none" aria-hidden>
            {current.flag}
          </span>
          {!compact && <span className="text-sm font-medium">{current.code}</span>}
          <ChevronDown className="h-3.5 w-3.5 opacity-60" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[200px] bg-background z-50">
        {SUPPORTED_CURRENCY_CODES.map((code) => {
          const c = CURRENCIES[code];
          const isActive = code === currency;
          return (
            <DropdownMenuItem
              key={code}
              onClick={() => setCurrency(code)}
              className="gap-2 cursor-pointer"
            >
              <span className="text-base" aria-hidden>
                {c.flag}
              </span>
              <span className="flex-1">
                <span className="font-medium">{c.code}</span>
                <span className="text-muted-foreground ml-2 text-xs">{c.name}</span>
              </span>
              {isActive && <Check className="h-4 w-4 text-primary" />}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
